<script module>
  export const meta = {
    title: 'Exclude specific movements',
    teaser:
      'Learn how to customize your Pausly sessions by excluding specific movements,\nensuring each session aligns with your personal needs and preferences for a\ntailored experience.',
    sort: 2,
  }
</script>

<p>
  Understanding the diverse needs and preferences of individuals, we've designed
  our platform to be as accommodating as possible with alternative movement
  settings. However, we recognize that each person and scenario is distinct, and
  there might be times when certain movements are not suitable or desirable.
</p>
<p>
  To ensure your sessions fit your needs perfectly, Pausly enables you to
  exclude specific movements.
</p>
<p>To exclude a movement:</p>
<ol>
  <li>Before the start of a session, select the "Options" button.</li>
  <li>Navigate to and choose the "Exclude specific movements" option.</li>
  <li>Click on any movement you prefer not to include.</li>
</ol>
<p>
  Pausly will then automatically substitute it with an alternative movement that
  aligns with your existing settings, ensuring your session remains seamless and
  tailored to your preferences.
</p>
